import styled from 'styled-components';
import { IconClosePanelLeft, IconOpenPanel } from '../icons';

const CollapseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  margin-left: ${({ theme }) => theme.space[1]}px;
  flex-shrink: 0;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: pointer;
  transition: none;
`;

export interface ButtonCollapseProps {
  collapsed: boolean;
  onClick: () => void;
}

export function ButtonCollapse({ collapsed, onClick }: ButtonCollapseProps) {
  return (
    <CollapseButton
      type="button"
      onClick={onClick}
      title={collapsed ? 'Развернуть меню' : 'Свернуть меню'}
      aria-label={collapsed ? 'Развернуть меню' : 'Свернуть меню'}
    >
      {collapsed ? <IconOpenPanel /> : <IconClosePanelLeft />}
    </CollapseButton>
  );
}
